<ng-container *ngFor="let option of batchOptionsSettings">
  <div class="batch-action-container" (click)="onBatchOptionClicked(option)">
    <span [ngClass]="option.icon"> </span>
    <span>
      {{ option.label }}
    </span>
  </div>
</ng-container>
